(() => {
  if (window.kcMediaLoading) return;
  window.kcMediaLoading = true;
  const selector = '[data-kc-media] > img, a[href*="/products/"] > img, .kc-menu-showcase__image > img, .kc-bundle-image > img';
  const observed = new WeakSet();
  const state = (img) => {
    const box = img.parentElement;
    if (!box?.hasAttribute('data-kc-media')) return;
    box.dataset.kcMediaState = img.complete ? (img.naturalWidth > 0 ? 'ready' : 'error') : 'loading';
    if (img.complete && img.naturalWidth > 0) img.classList.remove('opacity-0');
  };
  const watch = (img) => {
    const box = img.parentElement;
    if (!box.hasAttribute('data-kc-media')) {
      box.setAttribute('data-kc-media', '');
      box.classList.add('kc-media');
    }
    if (!observed.has(img)) {
      observed.add(img);
      img.addEventListener('load', () => state(img));
      img.addEventListener('error', () => state(img));
    }
    state(img);
  };
  const scan = (root) => {
    if (root.matches?.(selector)) watch(root);
    root.querySelectorAll?.(selector).forEach(watch);
  };
  scan(document);
  new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes') {
        if (record.target.matches(selector)) watch(record.target);
      } else record.addedNodes.forEach(scan);
    });
  }).observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['src','srcset','sizes']});
  window.addEventListener('pageshow', () => scan(document));
})();
